import { useRef } from "react";
import { motion, useInView } from "framer-motion";

const Line = ({ children, delay }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  return (
    <span ref={ref} className="block overflow-hidden">
      <motion.span
        className="block"
        initial={{ y: "110%" }}
        animate={inView ? { y: "0%" } : {}}
        transition={{ duration: 1, delay, ease: [0.16, 1, 0.3, 1] }}
      >
        {children}
      </motion.span>
    </span>
  );
};

const KeyLine = () => (
  <section data-testid="keyline-section" className="relative z-20 -mt-28">
    <div className="h-28 w-full rounded-t-[100%] bg-[#E6E6E6]" />
    <div className="bg-[#E6E6E6] px-6 pb-24 pt-8 text-center md:px-12 md:pb-32">
      <p className="font-mono text-[10px] tracking-[0.3em] text-black/40">
        THE DISTINCTION
      </p>
      <h2
        data-testid="keyline-headline"
        className="mx-auto mt-10 max-w-4xl font-display text-4xl font-light leading-tight text-[#080205] md:text-6xl"
      >
        <Line delay={0}>Transformation takes consistency.</Line>
        <Line delay={0.15}>
          Use your <span className="text-signal">psychology</span> to boost your drive.
        </Line>
      </h2>
    </div>
  </section>
);

export default KeyLine;
